import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setChatPageContext } from '|/app/purchase/checkout/constants/chat-page-context';
import { getChatSurface } from '|/app/purchase/checkout/constants/chat-surface-mappings';
import { StepName } from '|/app/services';
import { useBrand } from '|/brand';

const useChatPageContext = (stepUrl: string, stepId: StepName | null) => {
  const { pathname } = useLocation();
  const { brand } = useBrand();

  useEffect(() => {
    if (!pathname.includes('/steps/')) return;
    const surface = getChatSurface(stepUrl, brand) ?? getChatSurface(stepId ?? '', brand);
    if (!surface) return;
    setChatPageContext(surface);
  }, [stepUrl, stepId, pathname, brand]);
};

export default useChatPageContext;
